import PropTypes from 'prop-types';
import BaseLayout from '@components/Layout/BaseLayout';
import Styles from './Onboarding.module.scss';

const MainLayout = ({ children }) => {
  return (
    <BaseLayout
      pageHead={{
        title: `Get Started | Hire Digital`,
      }}>
      <div className={Styles.container}>{children}</div>
    </BaseLayout>
  );
};

MainLayout.propTypes = {
  children: PropTypes.node,
};

export default MainLayout;
